import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ className = "" }: { className?: string }) {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-9 h-9 flex items-center justify-center rounded-lg border border-dark-border text-silver hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer ${className}`}
      title={resolvedTheme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      {resolvedTheme === "dark" ? (
        <i className="ri-sun-line text-base" />
      ) : (
        <i className="ri-moon-line text-base" />
      )}
    </button>
  );
}

